import React, { FC } from 'react';
import { FilterOptions } from '../../reducers/filters.types';

type OptionsProps = {
    options: FilterOptions;
    keyPrefix: string;
};

export const SelectRadiusOptions: FC<OptionsProps> = ({
    options,
    keyPrefix
}) => {
    return (
        <>
            {options?.map((option) => {
                if (!option) {
                    return null;
                }
                const { value, label } = option;

                const key = `${keyPrefix}-${value}`;

                return (
                    <option key={key} value={value}>
                        {label}
                    </option>
                );
            })}
        </>
    );
};
